let body = $("html, body");
let ActiveGalleryView = false;
const slick = require('slick-carousel');
$('#Footer').addClass('mt-3')
if ($('.homepage-gallery').length) {
    $('#Footer').removeClass('mt-3').addClass('home-footer')

    $('.homepage-gallery').slick({
        centerMode: true,
        arrows: false,
        centerPadding: '220px',
        slidesToShow: 1,
        autoplay: true,
        // pauseOnHover: false,
        // autoplay: true,
        autoplaySpeed: 1700,
        responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    });
    $('.homepage-gallery').on('wheel', (function (e) {
        e.preventDefault();
        if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickNext');
        } else {
            $(this).slick('slickPrev');
        }
    }));





}



if ($('.slick-multi-row').length) {
    $('.slick-multi-row').slick({
        dots: true,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        rows: 2,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

if ($('.fairmont-gallery').length) {
    $('.fairmont-gallery').slick({
        infinite: false,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        responsive: [{
            breakpoint: 768,
            settings: {
                dots: true,
                arrows: false,
            }
        }]
    });
}

function CloseGallery() {
    ActiveGalleryView = false;
    $('.photo-gallery').slideUp();
    $('.wrapper-photo-gallery').removeClass('not-active')
}

if ($('.photo-gallery').length) {

    $(".photo-gallery").delegate(".close_gallery", "click", function () {
        CloseGallery()
    })
    $('.wrapper-photo-gallery').each(function () {
        let ActiveGallery = $(this);
        let thisGalleryWrapp = $('#' + $(this).data('gallery'));
        let ActiveGallerySlider = thisGalleryWrapp.find('.gallery');
        let DataUrl = $(this).data('url');

        ActiveGallery.click(function () {
            if (!ActiveGalleryView) {



                ActiveGallery.addClass('active')

                if ($(thisGalleryWrapp).find('.gallery').length > 0) {

                } else {
                    $(thisGalleryWrapp).html('');
                    var loader_html = "<div class='form_loader'>"
                    loader_html += "<span class='shape shape-1'> </span>";
                    loader_html += "<span class='shape shape-2'> </span>";
                    loader_html += "<span class='shape shape-3'> </span>";
                    loader_html += "<span class='shape shape-4'> </span>";

                    loader_html += "</div>";
                    $(thisGalleryWrapp).html(loader_html);
                    loadImages(DataUrl, thisGalleryWrapp);

                }


                $(thisGalleryWrapp).slideDown();
                body.stop().animate({
                    scrollTop: thisGalleryWrapp.offset().top - 50
                }, 800, 'swing', function () {});


                ActiveGalleryView = true;
                $('.wrapper-photo-gallery').addClass('not-active')


            } else {
                CloseGallery()

            }
            // if ((ActiveGallery).hasClass('active')) {
            //     thisGalleryWrapp.slideUp();
            //     ActiveGallery.removeClass('active');
            //     console.log('add active')


            // } else {


            //     $('.wrapper-photo-gallery').removeClass('active');
            //     ActiveGallery.addClass('active')
            //     loadImages(DataUrl, thisGalleryWrapp);

            // }
        });

    });
}


function loadImages(url, thisGalleryWrapp) {
    $.getJSON(url, function (data) {
        var mylist = "";
        if (typeof data === 'object') {
            $.each(data['images'], function (key, image) {
                mylist += '<div class="photo-wrap"><img class="img img-fluid" src="' + image['url'] + '" alt="' + image['title'] + '"></div>';

            });

            setTimeout(function () {



                $(thisGalleryWrapp).html('');

                var close_html = "<div class='close_gallery close'>"
                close_html += "<span class='close-img'> </span>";
                close_html += "</div>";

                body.stop().animate({
                    scrollTop: thisGalleryWrapp.offset().top - 50
                }, 800, 'swing', function () {});

                $(thisGalleryWrapp).html(close_html + '<div class="gallery"></div>');
                $(thisGalleryWrapp).find('.gallery').html(mylist);
                $(thisGalleryWrapp).find('.gallery').slick({
                    infinite: false,
                    speed: 500,
                    fade: true,
                    autoplay: true,

                    cssEase: 'linear',
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            dots: true,
                            arrows: false,
                        }
                    }]
                });

            }, 0);




            body.stop().animate({
                scrollTop: thisGalleryWrapp.offset().top - 50
            }, 800, 'swing', function () {});


        }
    });
};